// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-us[data-v-3aab22aa] .button-grey{background:#e53646;color:#fff}.about-us[data-v-3aab22aa] .button-grey:hover{background:#cc2130;color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
